/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxGamesLibWebRpcContractsResponseError } from './FxGamesLibWebRpcContractsResponseError';
import {
    instanceOfFxGamesLibWebRpcContractsResponseError,
    FxGamesLibWebRpcContractsResponseErrorFromJSON,
    FxGamesLibWebRpcContractsResponseErrorFromJSONTyped,
    FxGamesLibWebRpcContractsResponseErrorToJSON,
} from './FxGamesLibWebRpcContractsResponseError';

/**
 * @type FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError
 * 
 * @export
 */
export type FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError = FxGamesLibWebRpcContractsResponseError;

export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError {
    return FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebRpcContractsResponseError(json)) {
        return FxGamesLibWebRpcContractsResponseErrorFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(json: any): any {
    return FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxGamesLibWebRpcContractsResponseError(value)) {
        return FxGamesLibWebRpcContractsResponseErrorToJSON(value as FxGamesLibWebRpcContractsResponseError);
    }

    return {};
}

